var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as main from "../export";
import { ProfileContext, DeviceProfile, NewDeviceProfile } from "./DeviceProfileManager";
import axios from "axios";
export class ATRSigfoxProfileContext extends ProfileContext {
    constructor(accessKey, secret) {
        super();
        this.accessKey = accessKey;
        this.secret = secret;
    }
    serialize() {
        return {
            access_key: this.accessKey,
            secret: this.secret
        };
    }
}
export class ATRLoraTTNProfileContext extends ProfileContext {
    constructor(region, appId, joinEui, appKey, netKey, apiKey, dshApiKey) {
        super();
        this.region = region;
        this.appId = appId;
        this.joinEui = joinEui;
        this.appKey = appKey;
        this.netKey = netKey;
        this.apiKey = apiKey;
        this.dshApiKey = dshApiKey;
    }
    serialize() {
        return {
            region: this.region,
            application_id: this.appId,
            application_eui: this.joinEui,
            application_key: this.appKey,
            network_key: this.netKey,
            apikey: this.apiKey,
            dsh_api_key: this.dshApiKey,
        };
    }
}
export class ATRNewDeviceProfileSigfox extends NewDeviceProfile {
    constructor(id, label, converterId, context) {
        super(id, label, main.shared.types.DeviceConnectivity.SIGFOX, converterId, context);
    }
}
export class ATRNewDeviceProfileLorattn extends NewDeviceProfile {
    constructor(id, label, converterId, context) {
        super(id, label, main.shared.types.DeviceConnectivity.LORA_TTN, converterId, context);
    }
}
export class ATRNewDeviceProfileLoraloriot extends NewDeviceProfile {
    constructor(id, label, converterId) {
        super(id, label, main.shared.types.DeviceConnectivity.LORA_LORIOT, converterId, new ProfileContext());
    }
}
export class ATRNewDeviceProfileLoramachineq extends NewDeviceProfile {
    constructor(id, label, converterId) {
        super(id, label, main.shared.types.DeviceConnectivity.LORA_MACHINEQ, converterId, new ProfileContext());
    }
}
export class ATRNewDeviceProfileLoraactility extends NewDeviceProfile {
    constructor(id, label, converterId) {
        super(id, label, main.shared.types.DeviceConnectivity.LORA_ACTILITY, converterId, new ProfileContext());
    }
}
/**
 * @interface
 *
 * @name ATRDeviceProfileManager
 * @description Interface exposed by device profile manager Asset-Tracking microservice
 * @author STMicroelectronics, Davide Sergi
 */
export class ATRDeviceProfileManager {
    constructor(baseUrl, authorizer, region) {
        this.baseUrl = baseUrl;
        this.authorizer = authorizer;
        this.region = region;
    }
    getDeviceProfiles(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            /* User profiles */
            const url1 = new URL(`/v1/deviceprofiles`, this.baseUrl.href);
            const sigv4Descriptor1 = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "GET", url1.hostname, url1.pathname, url1.search, "", "execute-api", this.region);
            const authHeaders1 = this.authorizer.authorize(sigv4Descriptor1);
            const opt1 = {
                headers: authHeaders1
            };
            const r1 = yield axios.get(url1.href, opt1);
            const data1 = r1.data;
            const userProfiles = data1.map((d) => this.deserializeDeviceProfile(d));
            /* Default profiles */
            const url2 = new URL(`/v1/deviceprofiles`, this.baseUrl.href);
            const sigv4Descriptor2 = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "GET", url2.hostname, url2.pathname, "default_profiles=true", "", "execute-api", this.region);
            const authHeaders2 = this.authorizer.authorize(sigv4Descriptor2);
            const opt2 = {
                headers: authHeaders2,
                params: {
                    "default_profiles": true
                }
            };
            const r2 = yield axios.get(url2.href, opt2);
            const data2 = r2.data;
            const defaultProfiles = data2.map((d) => this.deserializeDeviceProfile(d));
            return userProfiles.concat(defaultProfiles);
        });
    }
    getDeviceProfile(id, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`/v1/deviceprofiles/${id}`, this.baseUrl.href);
            const sigv4Descriptor = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "GET", url.hostname, url.pathname, url.search, "", "execute-api", this.region);
            const authHeaders = this.authorizer.authorize(sigv4Descriptor);
            let opt = {
                headers: authHeaders
            };
            const response = yield axios.get(url.href, opt);
            const data = response.data;
            return this.deserializeDeviceProfile(data);
        });
    }
    createDeviceProfile(deviceProfile, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`/v1/deviceprofiles`, this.baseUrl.href);
            let rawDeviceProfile = {
                id: deviceProfile.id,
                technology: deviceProfile.connectivity.toString(),
                context: deviceProfile.context.serialize(),
                converter: deviceProfile.converterId
            };
            const sigv4Descriptor = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "POST", url.hostname, url.pathname, url.search, JSON.stringify(rawDeviceProfile), "execute-api", this.region);
            const authHeaders = this.authorizer.authorize(sigv4Descriptor);
            let opt = {
                headers: authHeaders
            };
            yield axios.post(url.href, rawDeviceProfile, opt);
        });
    }
    updateDeviceProfile(deviceProfile, credentials) {
        throw new Error("Method not implemented.");
    }
    deleteDeviceProfile(id, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`/v1/deviceprofiles/${id}`, this.baseUrl.href);
            const sigv4Descriptor = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "DELETE", url.hostname, url.pathname, url.search, "", "execute-api", this.region);
            const authHeaders = this.authorizer.authorize(sigv4Descriptor);
            let opt = {
                headers: authHeaders
            };
            yield axios.delete(url.href, opt);
        });
    }
    deserializeDeviceProfile(rawDeviceProfile) {
        const connectivityStr = rawDeviceProfile.technology;
        const connectivity = main.shared.types.deserializeDeviceConnectivity(connectivityStr);
        let deviceProfile;
        switch (connectivity) {
            case main.shared.types.DeviceConnectivity.LORA_TTN:
                const deviceLoraTTNProfileContext = new ATRLoraTTNProfileContext(rawDeviceProfile.context.region, rawDeviceProfile.context.application_id, rawDeviceProfile.context.application_eui, rawDeviceProfile.context.application_key, rawDeviceProfile.context.network_key, rawDeviceProfile.context.apikey, rawDeviceProfile.context.dsh_api_key);
                deviceProfile = new DeviceProfile(rawDeviceProfile.id, rawDeviceProfile.id, rawDeviceProfile.owner, main.shared.types.DeviceConnectivity.LORA_TTN, rawDeviceProfile.converter, deviceLoraTTNProfileContext, new Date(rawDeviceProfile.create_timestamp));
                break;
            case main.shared.types.DeviceConnectivity.LORA_LORIOT:
                deviceProfile = new DeviceProfile(rawDeviceProfile.id, rawDeviceProfile.id, rawDeviceProfile.owner, main.shared.types.DeviceConnectivity.LORA_LORIOT, rawDeviceProfile.converter, new ProfileContext(), new Date(rawDeviceProfile.create_timestamp));
                break;
            case main.shared.types.DeviceConnectivity.LORA_MACHINEQ:
                deviceProfile = new DeviceProfile(rawDeviceProfile.id, rawDeviceProfile.id, rawDeviceProfile.owner, main.shared.types.DeviceConnectivity.LORA_MACHINEQ, rawDeviceProfile.converter, new ProfileContext(), new Date(rawDeviceProfile.create_timestamp));
                break;
            case main.shared.types.DeviceConnectivity.LORA_ACTILITY:
                deviceProfile = new DeviceProfile(rawDeviceProfile.id, rawDeviceProfile.id, rawDeviceProfile.owner, main.shared.types.DeviceConnectivity.LORA_ACTILITY, rawDeviceProfile.converter, new ProfileContext(), new Date(rawDeviceProfile.create_timestamp));
                break;
            case main.shared.types.DeviceConnectivity.SIGFOX:
                const deviceSigfoxProfileContext = new ATRSigfoxProfileContext(rawDeviceProfile.context.access_key, rawDeviceProfile.context.secret);
                deviceProfile = new DeviceProfile(rawDeviceProfile.id, rawDeviceProfile.id, rawDeviceProfile.owner, main.shared.types.DeviceConnectivity.SIGFOX, rawDeviceProfile.converter, deviceSigfoxProfileContext, new Date(rawDeviceProfile.create_timestamp));
                break;
            default:
                throw new Error("Device profile: unsupported connectivity");
        }
        return deviceProfile;
    }
}
//# sourceMappingURL=ATRDeviceProfileManager.js.map